module.exports = __webpack_public_path__ + "img/DiNapoli-bg.7b9b38fc.png";